"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tersify = exports.defaultTersify = void 0;
var is_buffer_1 = __importDefault(require("is-buffer"));
var unpartial_1 = require("unpartial");
var constants_js_1 = require("./constants.js");
var hasTersifyFn_js_1 = require("./hasTersifyFn.js");
var tersifyFunction_js_1 = require("./tersifyFunction.js");
var trim_js_1 = require("./trim.js");
function defaultTersify(options) {
    return tersify(this, options);
}
exports.defaultTersify = defaultTersify;
function tersify(obj, options) {
    var context = (0, unpartial_1.required)(constants_js_1.defaultOptions, options, { path: [], references: [] });
    return tersifyValue(context, obj, context.maxLength);
}
exports.tersify = tersify;
function tersifyValue(context, value, length) {
    var valueType = getType(value);
    var func = tersifyFactory[valueType];
    // istanbul ignore next
    if (!func)
        throw new Error("Can't find fn for ".concat(JSON.stringify(value)));
    return func(context, value, length);
}
function getType(value) {
    if (value === undefined || value === null)
        return String(value);
    if (value instanceof RegExp)
        return 'RegExp';
    if (value instanceof Date)
        return 'Date';
    if (Array.isArray(value))
        return 'Array';
    if (value instanceof Error)
        return 'Error';
    if ((0, is_buffer_1.default)(value))
        return 'Buffer';
    var type = typeof value;
    if (type === 'object' && Object.getPrototypeOf(value) !== Object.prototype)
        return 'instance';
    return type;
}
var tersifyFactory = {
    'undefined': tersifyLiteral,
    'null': tersifyLiteral,
    'boolean': tersifyLiteral,
    'number': tersifyLiteral,
    'bigint': tersifyBigint,
    'instance': tersifyInstance,
    'string': tersifyString,
    'symbol': tersifySymbol,
    'function': tersifyFunction_js_1.tersifyFunction,
    'object': tersifyObject,
    'Buffer': tersifyBuffer,
    'Date': tersifyDate,
    'RegExp': tersifyRegExp,
    'Array': tersifyArray,
    'Error': tersifyError
};
function tersifyLiteral(context, node, length) {
    return (0, trim_js_1.trim)(context, String(node), length);
}
function tersifyDate(context, node, length) {
    return (0, trim_js_1.trim)(context, node.toISOString(), length);
}
function tersifyRegExp(context, node, length) {
    return (0, trim_js_1.trim)(context, String(node), length);
}
function tersifyString(context, value, length) {
    return (0, trim_js_1.trim)(context, "'".concat(value, "'"), length);
}
function tersifySymbol(context, node, length) {
    if (context.raw)
        return node.toString();
    return (0, trim_js_1.trim)(context, node.toString().replace('Symbol(', 'Sym('), length);
}
function tersifyBigint(context, value, length) {
    return (0, trim_js_1.trim)(context, String(value) + 'n', length);
}
function tersifyError(context, node, length) {
    var errorName = node.constructor.name;
    // 7 = length of `Error()`
    var trimmedMsg = (0, trim_js_1.trim)(context, "'".concat(node.message, "'"), length - 7);
    if (!node.message)
        return (0, trim_js_1.trim)(context, "".concat(errorName, "()"), length);
    if (trimmedMsg.length === 0)
        return (0, trim_js_1.trim)(context, "".concat(errorName, "( )"), length);
    return (0, trim_js_1.trim)(context, "".concat(errorName, "(").concat(trimmedMsg, ")"), length);
}
function tersifyBuffer(context, node, length) {
    return (0, trim_js_1.trim)(context, node.inspect(), length);
}
function tersifyArray(context, value, length) {
    var ref = context.references.find(function (r) { return r.value === value; });
    if (ref) {
        return "ref(".concat(ref.path.join(', '), ")");
    }
    context.references.push({ value: value, path: context.path });
    if (!context.raw && (0, hasTersifyFn_js_1.hasTersifyFn)(value) && value.tersify !== defaultTersify) {
        return value.tersify({ maxLength: length });
    }
    if (value.length === 0)
        return "[]";
    var bracketLen = 2;
    var entriesLen = 0;
    var commaAndSpaceLen = 2;
    var entries = value.reduce(function (entries, v, i) {
        var path = __spreadArray(__spreadArray([], context.path, true), [i], false);
        var str = tersifyValue(__assign(__assign({}, context), { path: path }), v, length - entriesLen);
        entriesLen += str.length;
        if (i !== value.length - 1)
            entriesLen += commaAndSpaceLen;
        entries.push(str);
        return entries;
    }, []);
    var content = (0, trim_js_1.trim)(context, entries.join(', '), length - bracketLen);
    if (content.length === 0)
        return (0, trim_js_1.trim)(context, "[ ]", length);
    return "[".concat(content, "]");
}
function tersifyObject(context, value, length) {
    var ref = context.references.find(function (r) { return r.value === value; });
    if (ref) {
        return "ref(".concat(ref.path.join(', '), ")");
    }
    context.references.push({ value: value, path: context.path });
    if (!context.raw && (0, hasTersifyFn_js_1.hasTersifyFn)(value) && value.tersify !== defaultTersify) {
        return value.tersify({ maxLength: length });
    }
    var bracketLen = 4;
    var remaining = length - bracketLen;
    var keys = Object.keys(value);
    var props = keys.reduce(function (p, k, i) {
        if (remaining > 0) {
            var isLastKey = i === keys.length - 1;
            var propStr = getPropStr(context, value, k, remaining, isLastKey);
            remaining -= propStr.length;
            p.push(propStr);
        }
        return p;
    }, []);
    var hasSkippedProps = keys.length > props.length;
    var content = hasSkippedProps ? props.join(', ') + ' ' : props.join(', ');
    var trimmedContent = (0, trim_js_1.trim)(context, content, length - bracketLen);
    return keys.length === 0 ? '{}' :
        trimmedContent.length === 0 ?
            (0, trim_js_1.trim)(context, "{   }", length) :
            "{ ".concat(trimmedContent, " }");
}
function tersifyInstance(context, value, length) {
    var _a, _b;
    var ref = context.references.find(function (r) { return r.value === value; });
    if (ref) {
        return "ref(".concat(ref.path.join(', '), ")");
    }
    context.references.push({ value: value, path: context.path });
    if (!context.raw && (0, hasTersifyFn_js_1.hasTersifyFn)(value) && value.tersify !== defaultTersify) {
        return value.tersify({ maxLength: length });
    }
    if (length <= 4)
        switch (length) {
            case 4: return '. {}';
            case 3: return '...';
            case 2: return '..';
            case 1: return '.';
            case 0: return '';
        }
    var proto = Object.getPrototypeOf(value);
    var name = (_b = (_a = proto === null || proto === void 0 ? void 0 : proto.constructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
    var bracketLen = 2; // `{}`
    var spaceLen = 1; // ' '
    var _c = length < (name.length + spaceLen + bracketLen) ?
        [length - spaceLen - bracketLen, bracketLen] :
        [name.length, length - name.length - spaceLen], nameLength = _c[0], valueLength = _c[1];
    var nameStr = nameLength ? "".concat((0, trim_js_1.trim)(context, name, nameLength), " ") : '';
    var remaining = valueLength;
    var keys = Object.keys(value);
    var props = keys.reduce(function (p, k, i) {
        if (remaining > 0) {
            var isLastKey = i === keys.length - 1;
            var propStr = getPropStr(context, value, k, remaining, isLastKey);
            remaining -= propStr.length;
            p.push(propStr);
        }
        return p;
    }, []);
    var hasSkippedProps = keys.length > props.length;
    var content = hasSkippedProps ? props.join(', ') + ' ' : props.join(', ');
    var trimmedContent = (0, trim_js_1.trim)(context, content, valueLength - bracketLen - 2);
    return keys.length === 0 ? "".concat(nameStr, "{}") :
        trimmedContent.length === 0 ?
            (0, trim_js_1.trim)(context, "".concat(nameStr, "{   }"), length) :
            "".concat(nameStr, "{ ").concat(trimmedContent, " }");
}
function getPropStr(context, bag, key, length, isLastKey) {
    var commaAndSpaceLen = isLastKey ? 0 : 2;
    var colonAndSpaceLen = 2;
    var path = __spreadArray(__spreadArray([], context.path, true), [key], false);
    var d = Object.getOwnPropertyDescriptor(bag, key);
    var accessor = [];
    if (d.get)
        accessor.push('Get');
    if (d.set)
        accessor.push('Set');
    if (accessor.length > 0) {
        return "".concat(getPropKey(key), ": [").concat(accessor.join('/'), "]");
    }
    var value = bag[key];
    if (typeof value === 'function') {
        var fnLen = 2;
        if ((/^(.*)\s?=>\s?/.test(value.toString()))) {
            var propValue = tersifyValue(__assign(__assign({}, context), { path: path }), value, length - key.length - commaAndSpaceLen - colonAndSpaceLen);
            return "".concat(getPropKey(key), ": ").concat(propValue);
        }
        else {
            var propValue = tersifyValue(__assign(__assign({}, context), { path: path }), value, length - key.length - commaAndSpaceLen + fnLen);
            var asyncToken = /^async fn/.test(propValue) ? 'async ' : '';
            var generatorToken = /^(async )?fn\*/.test(propValue) ? '*' : '';
            return "".concat(asyncToken).concat(generatorToken).concat(getPropKey(key)).concat(propValue.slice(propValue.indexOf('(')));
        }
    }
    else {
        // console.log(remaining, k.length, colonAndSpaceLen, commaAndSpaceLen, remaining - k.length - colonAndSpaceLen - commaAndSpaceLen)
        var propValue = tersifyValue(__assign(__assign({}, context), { path: path, noTrim: true }), value, length - key.length - colonAndSpaceLen - commaAndSpaceLen);
        return "".concat(getPropKey(key), ": ").concat(propValue);
    }
}
function getPropKey(key) {
    return key.indexOf('-') >= 0 ? "'".concat(key, "'") : key;
}
//# sourceMappingURL=tersify.js.map